<template>
  <div class="maintenanceManage">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :row-style="rowStyle"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span
              v-if="
                item.field === 'minQuantity' ||
                item.field === 'maxQuantity' ||
                item.field === 'registAsset'
              "
              >{{ Number(scope.row[item.field]).toFixed(2) }}</span
            >
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  import API from '@/api/purchaseSalesCenter/tradingQuota/applicationQuota.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import { filterEmpty } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'maintenanceManage',
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'mdPartnerType',
            name: this.$t('maintenanceManage.search.partnersType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('maintenanceManage.search.partnersTypePlaceholder'),
            options: this.partnerTypeList,
          },
          {
            prop: 'controlAreaCode',
            name: this.$t('maintenanceManage.search.businessDepartment'),
            placeholder: this.$t('maintenanceManage.search.businessDepartmentPlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_TREE,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
              currentStatus: '0',
            },
            clearable: false,
            normalizerFlag: true,
          },
          {
            prop: 'validStart',
            name: this.$t('maintenanceManage.search.validityStart'),
            clearabled: true,
            type: 'startDaterangePicker',
          },
          {
            prop: 'validEnd',
            name: this.$t('maintenanceManage.search.validityEnd'),
            clearabled: true,
            type: 'endDaterangePicker',
          },
          {
            prop: 'partnerZhName',
            name: this.$t('cooperation.label.partnerZhName'),
            type: 'searchTableSpec',
            searchType: 'partner',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('cooperation.placeholder.partnerZhName'),
          },
          {
            prop: 'creditLevel',
            name: this.$t('maintenanceManage.search.creditRating'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('maintenanceManage.search.creditRatingPlaceholder'),
            options: this.levelOptions,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        load: false,
        query: {
          mdPartnerType: null, //合作伙伴类型
          controlAreaCode: null, //事业部门
          validStart: null, //有效期从
          validEnd: null, //有效期到
          partnerName: null, //合作伙伴名称
          creditLevel: null, //信用级别
        },
        columnList: [],
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { type: 'seq', visible: true, width: '50', fixed: 'left', title: 'table.index' },
          {
            field: 'controlAreaCode',
            title: 'maintenanceManage.table.divisionCode',
            visible: true,
          },
          {
            field: 'controlAreaName',
            title: 'maintenanceManage.table.divisionName',
            visible: true,
          },
          {
            field: 'partnerTypeName',
            title: 'maintenanceManage.search.partnersType',
            visible: true,
          },
          {
            field: 'creditLevelName',
            title: 'maintenanceManage.search.creditRating',
            visible: true,
          },
          { field: 'partnerNo', title: 'maintenanceManage.table.partnersCode', visible: true },
          { field: 'partnerName', title: 'maintenanceManage.search.partnersName', visible: true },
          { field: 'registDate', title: 'maintenanceManage.table.setUpDate', visible: true },
          {
            field: 'registAsset',
            title: 'maintenanceManage.table.registeredCapital',
            visible: true,
          },
          {
            field: 'creditAccount',
            title: 'maintenanceManage.table.creditAccounts',
            visible: true,
          },
          {
            field: 'creditAccountDesc',
            title: 'maintenanceManage.table.creditAccountsPlaceholder',
            visible: true,
          },
          { field: 'validStart', title: 'maintenanceManage.search.validityStart', visible: true },
          { field: 'validEnd', title: 'maintenanceManage.search.validityEnd', visible: true },
          {
            field: 'minQuantity',
            title: 'maintenanceManage.table.unilateralTradeStart',
            visible: true,
          },
          {
            field: 'maxQuantity',
            title: 'maintenanceManage.table.unilateralTradeEnd',
            visible: true,
          },
          { field: 'quantityUnitName', title: 'maintenanceManage.table.unit', visible: true },
          { field: 'gmtCreate', title: 'maintenanceManage.table.creationDate', visible: true },
          {
            field: 'quantityCreatePersonName',
            title: 'maintenanceManage.table.founder',
            visible: true,
          },
          { field: 'mark', title: 'maintenanceManage.table.mark', visible: true },
        ],
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        levelOptions: [],
        partnerTypeList: [],
      };
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getDictList(); //数据字典
    },
    methods: {
      //获取数据字典下拉
      getDictList() {
        let tenantCode = this.userInfo.tenantCode;
        //通过数据字典获取信用等级下拉
        this.$axios.post(API.DATA_DICT, { dictType: 'credit_level', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.levelOptions = res.data.data;
          }
        });
        //通过数据字典获取合作伙伴类型下拉
        this.$axios.post(API.DATA_DICT, { dictType: 'partner_type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.partnerTypeList = res.data.data;
          }
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = Object.assign({ pageNum, pageSize }, query);
        if (params.partnerZhName && params.partnerZhName[0].partnerCode) {
          // params.partnerCode = params.partnerZhName[0].partnerCode;
          // params.partnerName = params.partnerZhName[0].partnerZhName;
          params.partnerNo =
            params.partnerZhName[0].allPartnerCode || params.partnerZhName[0].partnerCode; //客户
        }
        delete params.partnerZhName;
        this.$axios.post(API.GET_DATA_API, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = Math.floor(new Date().getTime() / (1000 * 60 * 60 * 24));
        let validEnd = Math.floor(new Date(row.validEnd).getTime() / (1000 * 60 * 60 * 24));
        if (validEnd < newDate) {
          return {
            backgroundColor: '#f0f0f0',
          };
        }
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          let path = {
            path: '/applicationQuota/addTransaction',
            name: 'addTransaction',
            meta: {
              keepAlive: true,
              title: this.$t('maintenanceManage.router.addTransaction'),
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'edit') {
          if (this.multipleSelection.length === 0) {
            return this.$message({
              showClose: true,
              message: this.$t('maintenanceManage.button.noSelectData'),
              type: 'error',
            });
          }
          let ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          let path = {
            path: '/applicationQuota/editTransaction',
            name: 'editTransaction',
            meta: {
              keepAlive: true,
              title: this.$t('maintenanceManage.router.editTransaction'),
            },
            query: {
              ids: JSON.stringify(ids),
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'export') {
          this.handleExport();
        }
      },
      // 导出
      handleExport() {
        const params = {
          ids: this.multipleSelection.map((item) => {
            return item.id;
          }),
          ...this.query,
        };
        this.$axios.post(API.EXPORT_API, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      /**页面必要代码End */
    },
  };
</script>
